import { render, staticRenderFns } from "./Form_Details.vue?vue&type=template&id=27c1a3b9&scoped=true"
import script from "./Form_Details.vue?vue&type=script&lang=js"
export * from "./Form_Details.vue?vue&type=script&lang=js"
import style0 from "./Form_Details.vue?vue&type=style&index=0&id=27c1a3b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c1a3b9",
  null
  
)

export default component.exports